import type { IControlOption } from '@/Interfaces/ControlOption.interface';
import type { GetOptionDisabled } from '@/types/Controls/TabSelect.types';
import { Checkbox, ListItemText, MenuItem, Typography } from '@mui/material';
import { useMemo } from 'react';

interface IProps {
  options?: IControlOption[];
  value?: IControlOption[];
  onChange: (value: IControlOption, checked: boolean) => void;
  getOptionDisabled?: GetOptionDisabled<IControlOption>;
}

const OptionsRenderer = ({ options, value, onChange, getOptionDisabled }: IProps) => {
  const selectedOptionValues = useMemo(() => {
    return new Set((value ?? []).map(({ value }) => value));
  }, [value]);

  return (options ?? []).map(option => {
    const checked = selectedOptionValues.has(option.value);
    const disabled = getOptionDisabled?.(option, value ?? [], checked);

    return (
      <MenuItem
        key={`${option.label}_${option.value}`}
        value={option.value}
        sx={{ paddingLeft: '4px' }}
        onClick={() => onChange(option, !checked)}
        selected={checked}
        disableRipple
        disabled={disabled}
      >
        <Checkbox checked={checked} disabled={disabled} />
        <ListItemText>
          <Typography variant='inherit' noWrap>
            {option.label}
          </Typography>
        </ListItemText>
      </MenuItem>
    );
  });
};

export default OptionsRenderer;
